// extracted by mini-css-extract-plugin
export default {"container":"PageComponent_container__mA-iu"};